// import { AxiosRequestConfig } from '@/public/fetch/type'
import { cryptoInstance } from '@/public/fetch';
// const userApi2 = process.env.VUE_APP_USER_PATH
import { userApi2 } from '@/public/utils/basePath';
const baseURL = userApi2;
export const login = (params) => {
    return cryptoInstance.post('/v2/user/login', params, {
        baseURL: userApi2,
        isFormData: true
    });
};
export const updateHeadUpload = (params) => {
    return cryptoInstance.post('/user/head/upload', params, {
        baseURL: userApi2,
        isNeedSign: true
    });
};
export const getRankList = (params) => {
    return cryptoInstance.get(`/v5/study_center/ranking/${params.userId}`, {
        baseURL: userApi2,
        params
    });
};
/**
 * 学习时长数据
 * @params
 * userId
 */
export const getLearnInfo = (params) => {
    return cryptoInstance.get(`/v5/study_center/top/${params.userId}`, {
        baseURL
    });
};
// 获取用户练习卡
export const getExerciseCard = (userId) => {
    return cryptoInstance.get(`/user/exerciseCard/init/${userId}`, {
        baseURL
    });
};
// 获取练习卡信息
export const getCardCoupon = (params, query) => {
    return cryptoInstance.get(`/user/exerciseCard/cardCoupon/${params.userId}/${params.cardId}`, {
        params: query,
        baseURL
    });
};
// 获取卡券详情
export const getCouponInfo = (userId, cardId) => {
    return cryptoInstance.get(`/user/exerciseCard/couponDetail/${userId}/${cardId}`, {
        baseURL
    });
};
// 申请状态
export const applyLogStatus = (userId) => {
    return cryptoInstance.get(`/user/logoff/status/${userId}`, {
        baseURL
    });
};
// 申请
export const applyLogOff = (userId) => {
    return cryptoInstance.get(`/user/logoff/apply/${userId}`, {
        baseURL
    });
};
// 取消注销
export const cancelApplyLog = (userId) => {
    return cryptoInstance.get(`/user/logoff/cancel/${userId}`, {
        baseURL
    });
};
// 获取用户科室
export const getDepId = (userId) => {
    return cryptoInstance.get(`/v5/study_center/getDepartment/${userId}`, {
        baseURL
    });
};
// 获取用户信息
export const getUserInfo = (userId) => {
    return cryptoInstance.get(`/user/user_info/${userId}`, {
        baseURL
    });
};
export const getGioUserStruct = (userId) => {
    return cryptoInstance.get(`/gio_user_struct/${userId}`, { baseURL });
};
// 包子充值
export const createBaozi = (userId, params) => {
    return cryptoInstance.get(`/user/account/record/create/${userId}`, {
        baseURL,
        params
    });
};
// 我的学币余额记录
export const getBalanceInfo = (userId) => {
    return cryptoInstance.get(`/user/account/balance_info/${userId}`, { baseURL });
};
// 获取消费记录
export const getRecordList = (params, query) => {
    return cryptoInstance.get(`/user/account/record_list/${params.type}/${params.userId}`, {
        params: query,
        baseURL
    });
};
// 获取权益
export const getUserRights = (params, query) => {
    return cryptoInstance.get(`/user/account/user_rights/${params.type}/${params.userId}`, {
        params: query,
        baseURL
    });
};
// 获取练习卡列表
export const getCardList = (userId) => {
    return cryptoInstance.get(`/v8/user/exerciseCard/init/${userId}`, { baseURL });
};
// 获取练习卡详情 tab
export const getCardTab = (userId, cardId) => {
    return cryptoInstance.get(`/v8/user/exerciseCard/cardCouponTab/${userId}/${cardId}`, {
        baseURL
    });
};
// 获取练习卡详情
export const getCardDetail = (userId, cardId, params) => {
    return cryptoInstance.get(`/v8/user/exerciseCard/cardCoupon/${userId}/${cardId}`, {
        baseURL,
        params
    });
};
// 获取券信息
export const getCouponDetail = (userId, couponId) => {
    return cryptoInstance.get(`/v8/user/exerciseCard/couponDetail/${userId}/${couponId}`, {
        baseURL
    });
};
// 创建会员订单
export const createVipOrder = (params) => {
    return cryptoInstance.get(`/user/vip/order/create`, { baseURL, params });
};
// 获取会员订单详情
export const getVipOrderDetail = (orderId) => {
    return cryptoInstance.get(`/user/vip/order/get/${orderId}`, { baseURL });
};
